export const useFullStoryEvent = () => {
  return (eventName = '', eventProperties = {}) => {
    const fullStoryWindowElement = window.FullStory || window.FS;

    if (fullStoryWindowElement) {
      fullStoryWindowElement.event(eventName, eventProperties);
    }
  };
};

export default useFullStoryEvent;
